<template>
  <div :id="page_slug">

    <div class="crumbs-bar">
      <el-row>
        <el-col :span="12">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ name: 'DashboardPage' }">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item>Quotes</el-breadcrumb-item>
          </el-breadcrumb>        
        </el-col>      
      </el-row>
    </div>

    <div class="actions-bar">
      <el-row>
        <el-col :span="8">
          &nbsp;
        </el-col>
        <el-col :span="14" :offset="2" class="text-right">
          <el-button v-if="quotes.length" :loading="loading.quote" type="default" @click="buildQuote()">Build Quote</el-button>
        </el-col>
      </el-row>
    </div>

    <el-alert
      v-if="quotes.length == 0"
      title="No Quote Items"
      type="info"
      description="There are currently no items in your quote area - visit the Product Catalogue to start adding products"
      style="margin-bottom:25px">
    </el-alert>

    
    <el-row>
       <el-card shadow="never" style="margin-bottom: 20px;" v-if="quotes.length != 0">
          <el-form 
            ref="quote_meta" 
            :model="quote_meta"
            :rules="rules.quote_meta">


            <el-tabs>

              <el-tab-pane label="Client Details">
            
                <el-form-item label="Client Name" prop="client_name">
                  <el-input v-model="quote_meta.client_name"></el-input>
                </el-form-item>

                <el-form-item label="Title" prop="title">
                    <el-input v-model="quote_meta.title"></el-input>
                </el-form-item>
            
                <el-form-item prop="date">
                  <el-date-picker
                    v-model="quote_meta.date"
                    style="margin-top:25px"
                    type="date"
                    :default-value="new Date()"
                    value-format="DD/MM/yyyy"
                    placeholder="Select Date">
                  </el-date-picker>
                </el-form-item>

              </el-tab-pane>

              <el-tab-pane label="Rep Details">

                <el-form-item label="Account Manager" prop="account_manager">
                    <el-input v-model="quote_meta.account_manager"></el-input>
                </el-form-item>

                <el-form-item label="Position" prop="position">
                    <el-input v-model="quote_meta.position"></el-input>
                </el-form-item>

               <el-form-item label="Mobile" prop="mobile">
                    <el-input v-model="quote_meta.mobile"></el-input>
                </el-form-item>

               <el-form-item label="Telephone" prop="telephone">
                    <el-input v-model="quote_meta.telephone"></el-input>
                </el-form-item>

               <el-form-item label="Email" prop="email">
                    <el-input v-model="quote_meta.email"></el-input>
                </el-form-item>

              <el-button @click="getUser()" type="primary" :loading="loading.profile">Load Profile</el-button>


              </el-tab-pane>

            </el-tabs>

          </el-form>




        </el-card>
      </el-row>

      <el-row v-for="(quote,index) in quotes" :key="index">
            <el-card shadow="never" style="margin-bottom: 20px;">

              <div slot="header" class="clearfix" style="line-height: 40px;">
                <span class="pull-right">
                  <el-button type="default" size="medium" @click="deleteAllQuotes(quote.id)" icon="el-icon-delete">Delete from Quote</el-button>
                </span>
              </div>

          <el-col :span="9">
            <img :src="quote.primary_image" :alt="quote.name" class="image-thumb" style="margin-bottom:20px;">
          </el-col>

          <el-col :span="15">
            <ul class="breakdown">
              <li class="clearfix">
                <span class="param">Name</span>
                <span class="value">{{quote.name}}</span>
              </li>
              <li class="clearfix">
                <span class="param">Specification</span>
                <span class="value">{{quote.specification}}</span>
              </li>
              <li class="clearfix">
                <span class="param">Short Description</span>
                <span class="value">{{quote.short_description}}</span>
              </li>
            </ul>

            <el-table
              :data="quote.pricing"
              border
              resizable="true"
              style="width: 100%;margin-bottom:20px;margin-top:20px;">

              <el-table-column
                prop="quantity"
                label="Quantity">
              </el-table-column>

              <el-table-column
                prop="price"
                label="Price">
                <template slot-scope="scope">
                  {{scope.row.price | toCurrency}} 
                  <span v-if="scope.row.unit_price_selected"> [Unit]</span>
                  <span v-else> [Total]</span>
                </template>
              </el-table-column>

              <el-table-column
                prop="turnaround_time"
                label="Turnaround">
                <template slot-scope="scope">
                  {{scope.row.turnaround_time + ' Days'}}
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                width="115%"
                label="Actions">
                <template slot-scope="scope">
                  <router-link :to="{ name: 'SupplierEdit', params: { id: scope.row.turnaround_time }}">
                    <el-button 
                      icon="el-icon-edit"
                      type="default" 
                      size="small">
                    </el-button>
                  </router-link>

                  <el-button 
                    icon="el-icon-delete" 
                    type="default" 
                    size="small"
                    @click="deleteSpecificQuote(quote.pricing, scope.row.price, scope.row.quantity)">
                  </el-button>
                </template>
              </el-table-column>
            </el-table> 

              <el-input
                type="textarea"
                :rows="5"
                v-model="quote.note">
              </el-input>

              <!-- <el-button type="primary" style="margin-top: 20px" @click="addNote(quote)">Update Note</el-button> -->
          </el-col>

        </el-card>
    </el-row>

    <pre>{{$data}}</pre>

  </div>
</template>

<style scoped>
  .row-style {
    margin-bottom: 20px;
  }

  .last-card {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .pull-right {
    float: right;
  }

  .image-thumb {
    width: 100%;
    border: 10px slateblue;
  }

  ul.breakdown {
    margin:0;
    padding:0;
    list-style: none;
  }

  ul.breakdown li {
    margin:5px 0 10px 0;
    padding:5px 0;
    /* border-bottom:1px solid #E4E7ED; */
    list-style: none;
  }

  ul.breakdown li span.param {
    display:inline-block;
    width:29%;
    font-weight: bold;
  }

  ul.breakdown li span.value {
    display:inline-block;
    width:70%;
  }

  .clearfix {
    overflow: auto;
  }

  .clearfix::after {
    content: "";
    clear: both;
    display: table;
  }
</style>

<script>
  import Config from '@/store/Config.js';
  import Quotes from '@/store/QuoteStash.js';
  import Tables from '@/store/Tables.js';
  import CountryList from '@/components/utils/CountryList.js';
  import jsPDF from 'jspdf';
  import jsPDFAutotable from 'jspdf-autotable';

  import base64Img from 'base64-img';

  import tempStore from '@/store/tempStore.js';

  export default {
    data: function() {
      return {
        page_alias: 'Quote List',
        page_slug: 'quote-list',

        quotes: Quotes.state.quotes,
        quote_meta: Quotes.state,
        config: Config.config,
        tempStore: tempStore.state,

        search_terms: '',

        loading: {
          profile: false,
          quote: false,
        },
        build_message: '',
        
        rules: {
          quote_meta: {
            client_name: [
              { required: true, message: 'Please enter a client name', trigger: 'blur' }
            ],
            title: [
              { required: true, message: 'Please enter a title', trigger: 'blur' }
            ],
            date: [
              { required: true, message: 'Please enter a date', trigger: 'blur' }
            ],
          },
        }
      };
    },

    mounted: function() {
      const me = this;
      
    },

    methods: {


      getUser: function() {
        console.log('Get User Function');
        const me = this;
        me.loading.profile = true;
        me.$http.get(me.config.api + 'user/2', {params: {id: me.$route.params.id}}).then(
        response => {
          console.log('Get User Function - Success Getting Data')  

          console.log(response.body.data);

          if(response.body.data.user_profile != null) {
            
            me.quote_meta.account_manager = response.body.data.firstName + ' ' + response.body.data.lastName;
            me.quote_meta.position = response.body.data.user_profile.position;
            me.quote_meta.email = response.body.data.email;
            me.quote_meta.mobile = response.body.data.user_profile.mobile;
            me.quote_meta.telephone = response.body.data.user_profile.telephone;
            
          } else {
            console.log('No profile data exists');

              me.$message({
                message: 'No Profile data found, once you complete your profile we can autoload it.',
                type: 'warning'
              });

          }

          me.loading.profile = false;
        }, response => {
          console.log('Get User Function - Error Getting Data');

          me.loading.profile = false;
        });
      },


      deleteAllQuotes: function(id) {
        const me = this;
        var index = me.quotes.findIndex(x => x.id == id);
        me.quotes.splice(index, 1);
      },

      deleteSpecificQuote: function(pricing, price, quantity) {
        const me = this;
        var index = pricing.findIndex(x => x.price == price && x.quantity == quantity);
        pricing.splice(index, 1);
      },

      buildQuote: function() {
        console.log('Build Quote Function');
        const me = this;
        me.loading.quote = true;
        me.build_message = 'Generating PDF';
        me.encodeImages();
      },    

      encodeImages: function(img_url) {
        console.log('Create Base64 Image Function');
        const me = this;

        /* NEEDED TO STOP HEADER / REQUEST / ETC. ERRORS */
        var proxy_url = 'https://cors-anywhere.herokuapp.com/';

        me.quotes.forEach(function(quote) {
          me.toDataURL(proxy_url + quote.primary_image, function(data_url) {
            quote.base64_image = data_url;
            console.log(data_url);
            me.build_message = 'Processing Images';
            if(Object.is(me.quotes[me.quotes.length - 1], quote)) {
              me.generatePDF();
            }
          })
        });
      },

      toDataURL: function(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
          var reader = new FileReader();
          reader.onloadend = function() {
            callback(reader.result);
          }
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      },

      generatePDF: function() {
        console.log('Generate PDF');
        const me = this;
        me.build_message = 'Quote building...';
        function toDataUrl(src, callback, outputFormat) {
          // console.log('Building image as base64');
          var img = new Image();
          img.crossOrigin = 'Anonymous';
          img.onload = function() {
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext('2d');
            var dataURL;
            canvas.height = this.height;
            canvas.width = this.width;
            ctx.drawImage(this, 0, 0);
            dataURL = canvas.toDataURL(outputFormat);
            callback(dataURL);
          };
          img.src = src;
          if (img.complete || img.complete === undefined) {
            img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
            img.src = src;
          }
        }
        
        toDataUrl(me.config.tsg_cover, function(base64Img) {
          me.build_message = 'Preparing images...'
          var cover = base64Img;
          //Define the document
          var doc = new jsPDF('l', 'mm', [148, 210]);
          // Elements used throughout
          var headerIcon = me.config.tsg_header_icon;
          var backCover = me.config.tsg_back_cover;
          // FRONT COVER
          doc.addPage()
          doc.setPage(1)
          doc.addImage(cover, 'JPEG', 0, 0, 210, 148);
          doc.setFontSize(18);
          doc.setFontType('bold');
          doc.setTextColor(0, 0, 0);
          doc.text(me.quote_meta.client_name, 10, 60);
          doc.setFontSize(13);
          doc.setFontType('bold');
          doc.setTextColor(236, 0, 140);
          doc.text(me.quote_meta.title, 10, 66);
          doc.setFontSize(11);
          doc.setFontType('normal');
          doc.setTextColor(0, 0, 0);
          doc.text(me.quote_meta.date, 10, 75);
          doc.setDrawColor(0);
          doc.setFillColor(255, 0, 140);
          doc.rect(0, 138, 210, 10, 'F');
          doc.setFontSize(10);
          doc.setFontType('bold');
          doc.setTextColor(255,255,255);
          doc.text('Bringing Brands to Life...Making Good Things Happen', 109, 144);
          doc.text('thesmartgroup.ie', 10, 144);
          // PAGES 
          var pageCount = 1;
          var item;
          // for (item in me.quotes) { 
          var itemData = me.quotes;
          console.log(me.quotes.length, itemData.length);
          var delete_all = false;
          itemData.forEach(function(item) {
            

            if(Object.is(me.quotes[me.quotes.length - 1], item)) {
              // delete_all = true; // clears the quotes after they are built
            }

            pageCount++;
            me.build_message = 'Preparing page', pageCount;
            // Check if last page so we don't add a blank one
            if (pageCount !== itemData.length) {
              doc.addPage();
            }
            // Set the page
            doc.setPage(pageCount);
            // Page Content
            doc.setFontSize(13);
            doc.setFontType('bold');
            doc.setTextColor(0, 0, 0);
            var productName = doc.splitTextToSize(item.name, 90);
            doc.text(10, 20, productName);
            doc.setLineWidth(0.1);
            doc.setDrawColor(190, 190, 190);
            doc.line(10, 30, 100, 30);
            doc.setFontSize(11);
            doc.setFontType('normal');
            var shortDescription = doc.splitTextToSize(item.short_description, 90);
            doc.text(10, 40, shortDescription);
            var columns = [ "Quantity", "Price", "Lead Time" ];
            var rows = [];
            var row = ''; //important to define this or row undefined error occurs
            item.pricing.forEach(function(element) {
              var unitPrice = '';
                if(element.price) {
                  if(element.unit_price_selected) {
                    unitPrice = element.price.toFixed(2) + ' [Unit Price]'
                  } else {
                    unitPrice = element.price.toFixed(2) + ' [Total Price]'
                  }
                } else {
                  unitPrice = '0.00'
                };

            var price = [ 
                element.quantity, 
                unitPrice,
                element.turnaround_time
              ];
              rows.push(price);
            });
            doc.autoTable(columns, rows, {margin: 10, startY: 60, tableWidth: 90, theme: 'grid', tableLineColor: 200, headerStyles: {fillColor: [236, 0, 140]}});
            doc.setFontSize(9);
            if (item.note) {
              var note = doc.splitTextToSize(item.note, 90);
              doc.text(10, 115, note);
            }
            doc.setFontSize(6);
            var disclaimer = doc.splitTextToSize('All prices are exclusive of VAT. All prices exclusive of delivery charges unless otherwise stated.', 90);
            doc.text(10, 132, disclaimer);
            doc.addImage(item.base64_image, 'JPEG', 110, 0, 104, 138);
            // hard coded image test
            // if (pageCount % 2  == 0) {
            //   doc.addImage(me.tempStore.i1, 'JPEG', 110, 0, 104, 138);
            // } else {
            //   doc.addImage(me.tempStore.i2, 'JPEG', 110, 0, 104, 138);
            // }
            // Page Header
            doc.setDrawColor(0);
            doc.setFillColor(236, 0, 140);
            doc.rect(0, 0, 110, 10, 'F');
            doc.setFontSize(9);
            doc.setFontType('bold');
            doc.setTextColor(255, 255, 255);
            doc.text('Presented to ' + me.quote_meta.client_name, 10, 6, 'left');
            doc.addImage(headerIcon, 'JPEG', 201, 2, 7, 7);
            // Page Footer
            doc.setDrawColor(0);
            doc.setFillColor(236, 0, 140);
            doc.rect(0, 138, 210, 10, 'F');
            doc.setFontSize(10);
            doc.setFontType('bold');
            doc.setTextColor(255,255,255);
            doc.text('Bringing Brands to Life...Making Good Things Happen', 109, 144);
            doc.text('thesmartgroup.ie', 10, 144);
          });
          if (itemData.length === 1) {
            doc.deletePage(3);
            console.log("Remove blank page");
          }
          // BACK COVER
          me.build_message = 'Finalising...';
          doc.addPage()
          doc.setPage(pageCount + 2)
          doc.addImage(backCover, 'JPEG', 0, 0, 210, 148);
          doc.setFontSize(22);
          doc.setFontType('bold');
          doc.setTextColor(255, 255, 255);
          doc.text('Thank you :)', 10, 45);
          doc.setFontSize(14);
          doc.setFontType('normal');
          doc.setTextColor(255, 255, 255);
          doc.text('Please Contact:', 10, 55);
          doc.setFontSize(12);
          doc.setFontType('normal');
          doc.setTextColor(255, 255, 255);
          doc.text(me.quote_meta.account_manager, 10, 65);
          doc.setFontSize(11);
          doc.setFontType('normal');
          doc.setTextColor(236, 0, 141);
          doc.text(me.quote_meta.position, 10, 70);
          doc.setTextColor(236, 0, 140);
          doc.setFontType('bold');
          doc.text('E:', 10, 80);
          doc.text('M:', 10, 87);
          doc.text('T:', 10, 94);
          doc.setFontType('normal');
          doc.setTextColor(255, 255, 255);
          doc.text(me.quote_meta.email, 18, 80);
          doc.text(me.quote_meta.mobile, 18, 87);
          doc.text(me.quote_meta.telephone, 18, 94);
          doc.setFontType('bold');
          doc.setTextColor(236, 0, 140);
          doc.text('Dublin Office', 10, 105);
          doc.setTextColor(255, 255, 255);
          doc.setFontType('normal');
          var dublinOffice = doc.splitTextToSize(me.quote_meta.dublin_office, 190);
          doc.text(dublinOffice, 10, 110);
          doc.setTextColor(236, 0, 140);
          doc.setFontType('bold');
          doc.text('Nenagh Office', 10, 120);
          doc.setTextColor(255, 255, 255);
          doc.setFontType('normal');
          var nenaghOffice = doc.splitTextToSize(me.quote_meta.nenagh_office, 190);
          doc.text(nenaghOffice, 10, 125);
          // FOOTER
          doc.setTextColor(236, 0, 140);
          doc.setDrawColor(0);
          doc.setFillColor(255, 0, 140);
          doc.rect(0, 138, 210, 10, 'F');
          doc.setFontSize(10);
          doc.setFontType('bold');
          doc.setTextColor(255,255,255);
          doc.text('Bringing Brands to Life...Making Good Things Happen', 109, 144);
          doc.text('thesmartgroup.ie', 10, 144);
          //RENDER PDF
          doc.save('QUOTE-' + Date.now() + '.pdf') 
          me.build_message = 'Quote building complete';
          if(delete_all) {
            me.quotes = [];
            me.quote_meta.quotes = [];
          }
          me.build_message = '';
          me.loading.quote = false;
        });
      } //LAST METHOD  
    } //END METHODS
  }
</script>


// WEBPACK FOOTER //
// src/pages/reps/QuoteList.vue